var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunyesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,128) scale(0.1,-0.1)",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286 1119 c-7 -9 -96 -889 -96 -935 l0 -26 119 0 120 0 6 43 c5 39     75 736 75 750 0 4 50 7 111 7 121 0 164 -12 199 -58 24 -30 27 -98 4 -130     -21 -30 -104 -71 -158 -78 -43 -6 -46 -9 -95 -89 -28 -45 -51 -85 -51 -89 0     -4 57 -86 127 -183 l126 -176 66 7 c36 3 99 6 140 6 56 0 72 3 68 13 -3 7     -60 89 -127 183 -68 93 -125 177 -128 187 -4 14 2 17 34 17 86 1 195 81 234     173 30 69 37 160 17 210 -40 95 -111 149 -217 166 -78 13 -567 15 -574 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunyesLogo);
export default __webpack_public_path__ + "static/media/runyes_logo.f71e16ba373f1e7569bb65d1a2eb3b40.svg";
export { ForwardRef as ReactComponent };